import {PropsWithChildren, RefObject} from 'react';

type Props = {
  id: string;
  label: string;
  ref?: RefObject<HTMLDivElement>;
  className?: string;
} & PropsWithChildren;

export default function QuantitieInputRoot({
  id,
  label,
  ref,
  children,
  className,
}: Props) {
  return (
    <div className={className} ref={ref}>
      <div className="relative">
        <label
          className="text-sm text-gray-700 leading-[1.8] w-fit"
          htmlFor={id}>
          {label}
        </label>
        {children}
      </div>
    </div>
  );
}
